import React, { createContext, useCallback, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Keep client records only in memory. They include PII and must not be persisted to localStorage.
  const [clientListCache, setClientListCache] = useState({});

  const updateClientListCache = useCallback((portalUserId, updater) => {
    if (!portalUserId) return;

    setClientListCache((cache) => {
      const current = cache[portalUserId] || {};
      const next = typeof updater === "function" ? updater(current) : updater;
      return {
        ...cache,
        [portalUserId]: next,
      };
    });
  }, []);

  const clearClientListCache = useCallback((portalUserId) => {
    if (!portalUserId) return;

    setClientListCache((cache) => {
      const { [portalUserId]: ignored, ...remaining } = cache;
      return remaining;
    });
  }, []);

  return (
    <AppContext.Provider
      value={{ clientListCache, updateClientListCache, clearClientListCache }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
